export const textureExists = (material?: IMaterial) => {
  const { texture, textureId } = material ?? {};
  const len = Object.keys(texture ?? {}).length;

  return textureId || len > 0;
};
